import { useState } from "react";
import { trendPlatforms, type TrendItem } from "@/mocks/hotTrends";

function TrendArrow({ trend }: { trend: TrendItem["trend"] }) {
  if (trend === "new") {
    return <span className="flex h-5 w-5 items-center justify-center rounded bg-accent-500 text-[10px] font-bold text-foreground-950">新</span>;
  }
  if (trend === "hot") {
    return <i className="ri-fire-fill text-primary-500" aria-hidden="true" />;
  }
  return <i className={trend === "up" ? "ri-arrow-up-s-line text-primary-500" : "ri-arrow-down-s-line text-foreground-500"} aria-hidden="true" />;
}

export default function HotTrends() {
  const [activeKey, setActiveKey] = useState(trendPlatforms[0].key);
  const active = trendPlatforms.find((p) => p.key === activeKey) ?? trendPlatforms[0];

  return (
    <section id="trend" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-bebas text-sm tracking-[0.2em] text-primary-500">LIVE HOT SEARCH</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              实时热搜 · <span className="text-primary-500">今日风向</span>
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              汇总近期各平台关于哇偶姐姐的高讨论话题，看哪些瓜最热、风向往哪吹。点击平台标签即可切换榜单。
            </p>
          </div>
        </div>

        {/* platform tabs */}
        <div className="mt-7 inline-flex flex-wrap items-center gap-1 rounded-full bg-background-200 p-1">
          {trendPlatforms.map((p) => (
            <button
              key={p.key}
              type="button"
              onClick={() => setActiveKey(p.key)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                activeKey === p.key
                  ? "bg-background-50 font-semibold text-foreground-950"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              <i className={`${p.icon} text-base`} aria-hidden="true" />
              {p.name}
              <span
                className={`hidden h-5 min-w-[20px] items-center justify-center rounded-full px-1 text-[11px] text-background-50 sm:inline-flex ${p.tone}`}
              >
                {p.items.length}
              </span>
            </button>
          ))}
        </div>

        {/* list */}
        <ol className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
          {active.items.map((item, i) => (
            <li
              key={`${active.key}-${item.rank}`}
              className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
            >
              <span
                className={`font-bebas w-9 shrink-0 text-center text-2xl ${
                  i < 3 ? "text-primary-500" : "text-foreground-400"
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-[15px] font-medium text-foreground-900">{item.tag}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{active.name} · {item.heat} 讨论</p>
              </div>
              <div className="flex items-center gap-1.5">
                <TrendArrow trend={item.trend} />
                {item.hot && (
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                    <i className="ri-fire-line" aria-hidden="true" />爆
                  </span>
                )}
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-6 text-center text-xs text-foreground-500">
          榜单为简化演示数据，反映讨论趋势概览。实际热度请以各平台实时榜单为准。
        </p>
      </div>
    </section>
  );
}